import { useMemo, useRef } from "react";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { changeLocale, getLocale, SUPPORTED_LOCALES, useTranslation } from "./i18n";
import { Locale } from "./resources";

interface LanguageSwitcherProps {
  className?: string;
  publicPage?: boolean;
}

const localeLabels: Record<Locale, string> = {
  vi: "common.vietnamese",
  en: "common.english",
  zh: "common.chinese",
  ja: "common.japanese",
  ko: "common.korean",
};

export function LanguageSwitcher({ className = "", publicPage = false }: LanguageSwitcherProps) {
  const menu = useRef<Menu>(null);
  const { t } = useTranslation();
  const currentLocale = getLocale();

  const items = useMemo(
    () =>
      SUPPORTED_LOCALES.map((locale) => ({
        label: t(localeLabels[locale]),
        icon: currentLocale === locale ? "pi pi-check" : "pi pi-globe",
        command: () => {
          if (locale !== currentLocale) {
            void changeLocale(locale);
          }
        },
      })),
    [currentLocale, t],
  );

  return (
    <span className={`language-switcher ${publicPage ? "language-switcher-public" : ""} ${className}`.trim()}>
      <Menu model={items} popup ref={menu} />
      <Button
        type="button"
        className="p-button-text language-switcher-button"
        icon="pi pi-globe"
        label={currentLocale.toUpperCase()}
        aria-label={t("common.language")}
        onClick={(event) => menu.current?.toggle(event)}
      />
    </span>
  );
}
